// SiteUp: "li isso" das notas de versao, por usuario, em ui_settings.
// Chave escalar `release_notes_seen_build` (o inteiro do build), nunca objeto
// e nunca localStorage: a preferencia acompanha a conta em qualquer aparelho.
// Ausente significa tudo nao lido, igual ao `seenVersionOf` do onboarding.
import { computed, ref } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import {
  LATEST_BUILD,
  RELEASES,
  isUnread as isBuildUnread,
  seenBuildOf,
} from 'dashboard/helper/releaseNotes';

export const RELEASE_NOTES_SEEN_KEY = 'release_notes_seen_build';

export function useReleaseNotes() {
  const { uiSettings, updateUISettings } = useUISettings();

  const storedBuild = computed(() =>
    seenBuildOf(uiSettings.value?.[RELEASE_NOTES_SEEN_KEY])
  );

  // Snapshot capturado uma vez: a tela marca tudo como visto ao abrir, e sem
  // congelar aqui o selo Novo sumiria na frente da pessoa enquanto ela le.
  const seenBuild = ref(storedBuild.value);

  const releases = computed(() => RELEASES);
  const latestRelease = computed(() => RELEASES[0] || null);

  // Vivo de proposito (o ponto no cartao Sistema do Hub tem que apagar depois
  // da visita), ao contrario do snapshot que manda no selo de cada item.
  const hasUnread = computed(() =>
    isBuildUnread(LATEST_BUILD, storedBuild.value)
  );

  const isUnread = build => isBuildUnread(build, seenBuild.value);

  const markAllRead = () => {
    if (storedBuild.value === LATEST_BUILD) return;
    updateUISettings({ [RELEASE_NOTES_SEEN_KEY]: LATEST_BUILD });
  };

  return {
    releases,
    seenBuild,
    hasUnread,
    latestRelease,
    isUnread,
    markAllRead,
  };
}
